import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.automatedLendingDecision.decisionError.noDirectorDetailsError.title',
        defaultMessage: 'Did you give the right name?'
    },
    verifyIdentity: {
        id: '_.automatedLendingDecision.decisionError.noDirectorDetailsErrorUK.verifyIdentity',
        defaultMessage:
            "It looks like the name you gave doesn't match any of the active directors Companies House list for your business. "
    },
    applicationDetailsCheck: {
        id: '_.automatedLendingDecision.decisionError.noDirectorDetailsErrorUK.applicationDetailsCheck',
        defaultMessage: `Click here if your name isn't "{checkNameDetailsLink}" or company isn't "{checkCompanyDetailsLink}. Update them if they are wrong and we'll take another look."`
    }
});
